import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=c55f0ff6&scoped=true"
import script from "./SlideProduct.vue?vue&type=script&lang=js"
export * from "./SlideProduct.vue?vue&type=script&lang=js"
import style0 from "./SlideProduct.vue?vue&type=style&index=0&id=c55f0ff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55f0ff6",
  null
  
)

export default component.exports